import React from 'react';
import { MLink } from './ManualLink';
import {
  TspContent2,
  TspContent2_1,
  TspContent2_2,
  TspContent2_3,
  TspContent2_4,
  TspContent3,
  TspContent3_1,
  TspContent3_2,
  TspContent3_3,
  TspContent3_4,
  DashboardManualBody,
  TspContent8,
} from './TspManualContent';

/* ── 1. 메인화면 (USP Home 기준) ── */

function UspContent1() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        사업공고·시설이용·전문가 자문 등 AI 기업지원 서비스로 이동할 수 있는 바로가기와 주요 공고, 시설 안내를 한눈에 확인할 수 있는 홈 화면입니다.
      </p>
      <ul className="menual-contents">
        <li>
          <p className="txt semibold">① GNB (상단 메뉴)</p>
          <ul className="menual-list">
            <li>사업공고, 시설예약, 자문·코디네이팅, 커뮤니티, 이용지원, 마이페이지 등 주요 메뉴를 이용할 수 있습니다.</li>
            <li>[돋보기] 클릭 시 통합검색으로 이동합니다.</li>
            <li>[햄버거] 클릭 시 전체 메뉴(사이트맵)가 노출됩니다.</li>
          </ul>
        </li>
        <li>
          <p className="txt semibold">② 메인 배너</p>
          <ul className="menual-list">
            <li>최대 5개 자동 롤링, [&lt;] [II] [&gt;] 클릭 시 이전/정지/다음 이동</li>
            <li>배너 클릭 시 해당 상세 페이지로 이동합니다.</li>
          </ul>
        </li>
        <li>
          <p className="txt semibold">③ 공고·소식 영역</p>
          <ul className="menual-list">
            <li>
              탭 메뉴 : 모집공고 / 선정결과공고 / 국가사업안내 / 공지사항 — 탭 선택 시 해당 유형의 최근 게시 목록으로 바뀝니다.
            </li>
            <li>각 탭별로 최대 5건까지 목록이 표시됩니다.</li>
            <li>항목 클릭 시 해당 상세 페이지로 이동합니다.</li>
            <li>[더보기] 클릭 시 선택한 탭에 해당하는 목록 화면으로 이동합니다.</li>
          </ul>
        </li>
        <li>
          <p className="txt semibold">④ 퀵메뉴</p>
          <ul className="menual-list">
            <li>
              사업공고, 시설 이용신청, 전문가자문단 조회, 코디네이팅 신청, 평가위원 신청, 국가사업안내
            </li>
            <li>각 카드 클릭 시 해당 서비스 메뉴로 이동합니다.</li>
          </ul>
        </li>
        <li>
          <p className="txt semibold">⑤ 시설 이용</p>
          <ul className="menual-list">
            <li>AI 집적단지, 창업캠프 시설 소개 카드가 노출됩니다.</li>
            <li>[바로가기] 클릭 시 각 시설에 맞는 시설 이용신청 경로로 이동합니다.</li>
          </ul>
        </li>
        <li>
          <p className="txt semibold">⑥ 광주 전문가 자문단 소개</p>
          <ul className="menual-list">
            <li>탭 메뉴 : 전체 및 분야별(공통코드 기준) 자문단 분류</li>
            <li>탭 선택 시 해당 분야 자문위원 목록이 갱신됩니다.</li>
            <li>카드에서 소속·경력 요약을 확인할 수 있으며, [상세보기]로 자문위원 상세로 이동합니다.</li>
            <li>PC·모바일 환경에 따라 그리드 또는 슬라이드 형태로 목록이 표시됩니다.</li>
            <li>[+] 더보기 클릭 시 전문가자문단 조회 메뉴로 이동합니다.</li>
            <li>하단 [지원하러 가기]·[제출하러 가기]는 로그인 후 마이페이지의 자문 관련 메뉴로 연결됩니다.</li>
          </ul>
        </li>
        <li>
          <p className="txt semibold">⑦ 시설 위치 안내</p>
          <ul className="menual-list">
            <li>광주 AI 집적단지, 창업캠프 1·2호 위치를 지도에서 선택해 볼 수 있습니다.</li>
            <li>지점 버튼·모바일 선택 시 해당 시설의 주소·운영시간·연락처 안내가 바뀝니다.</li>
            <li>[상세보기] 클릭 시 시설 예약·안내 관련 화면으로 이동합니다.</li>
          </ul>
        </li>
        <li>
          <p className="txt semibold">⑧ 유관사이트</p>
          <ul className="menual-list">
            <li>AICA, 광주광역시, NIPA, 과학기술정보통신부 등 로고가 자동 롤링됩니다.</li>
            <li>로고 클릭 시 해당 기관 사이트가 새 창으로 열립니다.</li>
          </ul>
        </li>
        <li>
          <p className="txt semibold">⑨ 푸터</p>
          <ul className="menual-list">
            <li>개인정보처리방침, 이용약관, 자주묻는질문, 사용자매뉴얼 링크를 이용할 수 있습니다.</li>
            <li>SNS 아이콘(인스타그램, 유튜브, 페이스북) 클릭 시 해당 채널로 이동합니다.</li>
            <li>주소 : 전남광주통합특별시 북구 삼소로 77 / 대표번호 : 062-610-3900 / 장애문의 : 062-610-3919</li>
          </ul>
        </li>
      </ul>
    </div>
  );
}

/* ══════════════════════════════════════════
   4. 시설예약
   ══════════════════════════════════════════ */

function UspContent4() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        시설 안내를 확인하고 AI 집적단지 및 AI 창업캠프 시설 이용을 위해 예약 신청을 할 수 있습니다. 이용 신청은 시설 선택 → 예약 정보 입력 → 신청서 작성 → 신청 완료 순서로 진행됩니다.
      </p>
    </div>
  );
}

function UspContent4_1() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        📌 시설예약 &gt; <MLink to="/Community/FacilityGroupReservation">시설안내</MLink>
      </p>
      <ul className="menual-list">
        <li>AI 집적단지, AI 창업캠프 1호, AI 창업캠프 2호 탭을 선택하여 시설별 정보를 확인하세요.</li>
        <li>시설별 위치, 층별 안내, 이용 시간 및 이용 절차를 확인할 수 있습니다.</li>
        <li>[오시는 길] 클릭 시 지도 페이지로 이동합니다.</li>
      </ul>
    </div>
  );
}

function UspContent4_2() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        시설별 예약 가능 일자를 확인하고 이용 신청을 진행합니다.
      </p>
    </div>
  );
}

function UspContent4_2_1() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        📌 시설예약 &gt; <MLink to="/FacilityReservation/ReservationUseDirect">시설 이용신청</MLink> &gt; AI 집적단지
      </p>

      <p className="txt">① 시설 선택</p>
      <ul className="menual-list">
        <li>목록에서 예약하고자 하는 시설 카드를 선택하세요.</li>
        <li>시설명, 수용인원, 이용대상, 이용료를 확인할 수 있습니다.</li>
        <li>[상세보기] 클릭 시 시설 상세 정보 팝업이 노출됩니다.</li>
      </ul>

      <p className="txt">② 예약 일자 및 시간 선택</p>
      <ul className="menual-list">
        <li>캘린더에서 예약할 날짜를 선택하세요. (당일 예약 불가)</li>
        <li>사용 시간을 선택하세요. (최소 1시간 이상)</li>
      </ul>

      <p className="txt">③ 신청서 작성 및 완료</p>
      <ul className="menual-list">
        <li>이용 목적 및 참석 인원을 입력하세요.</li>
        <li>[신청하기] 클릭 시 신청이 완료되며, 마이페이지 &gt; 시설예약관리로 이동합니다.</li>
      </ul>
    </div>
  );
}

function UspContent4_2_2() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        📌 시설예약 &gt; <MLink to="/FacilityReservation/ReservationUseStartUp">시설 이용신청</MLink> &gt; AI 창업캠프 1·2호
      </p>
      <ul className="menual-list">
        <li>AI 창업캠프 1호 또는 2호를 선택하세요.</li>
        <li>회의실, 교육실 등 원하는 시설의 [예약하기]를 클릭하세요.</li>
        <li>예약 일자와 시간을 선택한 후 신청 버튼을 클릭하세요.</li>
      </ul>
    </div>
  );
}

function UspContent4_3() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        신청한 시설 예약 내역의 처리 현황을 확인하고 취소할 수 있습니다.
      </p>
    </div>
  );
}

function UspContent4_3_1() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        📌 마이페이지 &gt; <MLink to="/MyPage/UsageMmt/FacilityReservationMmt">시설예약관리</MLink>
      </p>
      <ul className="menual-list">
        <li>신청한 시설의 예약 상태를 확인할 수 있습니다.</li>
        <li>상태 필터 : 전체 / 신청 / 승인 / 반려 / 취소 / 결제대기 / 결제완료</li>
        <li>[예약취소] : 승인 전 상태인 경우 예약을 취소할 수 있습니다.</li>
        <li>반려된 경우 클릭 시 상세 팝업에서 반려 사유를 확인할 수 있습니다.</li>
      </ul>
    </div>
  );
}

function UspContent4_3_2() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        📌 마이페이지 &gt; <MLink to="/MyPage/UsageMmt/FacilityReservationMmt">시설예약관리</MLink>
      </p>
      <ul className="menual-list">
        <li>신청 내역 리스트에서 시설명, 이용일시, 상태를 확인할 수 있습니다.</li>
        <li>상세 내역 클릭 시 신청 시 입력한 정보를 확인할 수 있습니다.</li>
        <li>이용 완료 후에는 해당 내역에서 설문조사 참여가 가능합니다. (해당 시)</li>
      </ul>
    </div>
  );
}

/* ══════════════════════════════════════════
   5. 지원사업안내
   ══════════════════════════════════════════ */

function UspContent5Intro() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        국가에서 시행하는 다양한 AI 관련 지원사업 정보를 확인하고 해당 사업의 상세 페이지로 연결하여 정보를 제공합니다.
      </p>
    </div>
  );
}

function UspContent5_1() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        📌 지원사업안내 &gt; <MLink to="/Notice/BusinessInfoNoti">국가사업안내</MLink>
      </p>
      <ul className="menual-list">
        <li>검색 : 사업명 기준 검색 가능</li>
        <li>필터 : 지원분야, 지역, 업력으로 선택하여 검색 가능합니다.</li>
        <li>목록은 최대 10개씩 노출되며, 각 사업 카드를 확인할 수 있습니다.</li>
        <li>각 사업 항목에서는 지원분야, 지역, 업력, 주관기관, 접수기간 정보를 확인 할 수 있습니다.</li>
        <li>상세 내용의 '본 공고 바로가기' 클릭 시 해당 사업을 주관하는 외부 사이트(사업공고 상세 페이지)가 새창으로 열립니다.</li>
      </ul>
    </div>
  );
}

/* ══════════════════════════════════════════
   6. 코디네이팅·자문 신청
   ══════════════════════════════════════════ */

function UspContent6() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        기업의 애로사항 해결을 위한 전문가 코디네이팅 및 자문 서비스를 신청할 수 있습니다.
      </p>
    </div>
  );
}

function UspContent6_1() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        📌 코디네이팅·자문 신청 &gt; <MLink to="/AdvisoryCoordinating/AdvisoryCoordinatingNoti">코디네이팅·자문 안내</MLink>
      </p>
      <ul className="menual-list">
        <li>코디네이팅 및 전문가 자문 서비스의 지원 대상, 지원 내용, 진행 절차를 확인할 수 있습니다.</li>
        <li>신청 시 유의사항 및 필수 제출 서류 목록을 확인하세요.</li>
        <li>[코디네이팅 신청] 또는 [전문가 자문 신청] 클릭 시 해당 신청 페이지로 이동합니다.</li>
      </ul>
    </div>
  );
}

function UspContent6_2() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        📌 코디네이팅·자문 신청 &gt; <MLink to="/AdvisoryCoordinating/CoordinatingApplication">코디네이팅 신청</MLink>
      </p>

      <p className="txt">① 신청 정보 입력</p>
      <ul className="menual-list">
        <li>신청자 정보를 입력하세요.</li>
        <li>AI사업분야(주력분야)를 선택하세요.</li>
        <li>기업 현황 및 신청 상세를 기입하세요.</li>
        <li>사업자등록증은 필수 제출입니다.</li>
      </ul>

      <p className="txt">② [신청] 클릭 시 코디네이팅 신청이 완료됩니다.</p>
    </div>
  );
}

function UspContent6_3() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        📌 마이페이지 &gt; AI 기업지원 &gt; <MLink to="/MyPage/AdvisoryCoordinatingMmt/ApplicationMmt">코디네이팅·자문 관리</MLink>
      </p>
      <ul className="menual-list">
        <li>신청한 코디네이팅의 접수 상태 및 처리 결과를 확인할 수 있습니다.</li>
        <li>상태 필터 : 신청 / 보완요청 / 신청취소 / 승인</li>
        <li>보완요청된 경우 상세 페이지에서 사유를 확인하고 수정 후 재신청할 수 있습니다.</li>
      </ul>
    </div>
  );
}

function UspContent6_4() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        📌 코디네이팅·자문 신청 &gt; <MLink to="/AdvisoryCoordinating/AdvisoryGroupInfo">전문가 자문단 조회</MLink>
      </p>
      <ul className="menual-list">
        <li>분야별로 등록된 전문가 자문단 풀(Pool)을 확인할 수 있습니다.</li>
        <li>검색 : 전문가 성명 및 주요 분야 기준 검색 가능</li>
        <li>필터 : 위촉연도 및 주요분야 대분류/중분류로 선택 가능</li>
        <li>[자문단 지원하기]를 클릭하면 자문단에 직접 지원할 수 있습니다.</li>
      </ul>
    </div>
  );
}

function UspContent6_5() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        📌 코디네이팅·자문 신청 &gt; <MLink to="/AdvisoryCoordinating/AdvisoryApplication">전문가 자문 신청</MLink>
      </p>

      <p className="txt">① 신청 정보 입력</p>
      <ul className="menual-list">
        <li>신청자 정보를 입력하세요.</li>
        <li>AI사업분야(주력분야)를 선택하세요.</li>
        <li>기업 현황 및 신청 상세를 기입하세요.</li>
      </ul>

      <p className="txt">② [신청] 클릭 시 전문가 자문 신청이 완료됩니다.</p>
    </div>
  );
}

function UspContent6_6() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        📌 마이페이지 &gt; AI 기업지원 &gt; <MLink to="/MyPage/AdvisoryCoordinatingMmt/ApplicationMmt">전문가 자문 신청 내역</MLink>
      </p>
      <ul className="menual-list">
        <li>신청한 전문가 자문의 접수 상태 및 처리 결과를 확인할 수 있습니다.</li>
        <li>상태 필터 : 신청 / 보완요청 / 신청취소 / 승인 / 자문완료</li>
        <li>보완요청된 경우 상세 페이지에서 사유를 확인하고 수정 후 재신청할 수 있습니다.</li>
        <li>자문 완료 후 만족도 조사 버튼이 활성화 됩니다.</li>
      </ul>
    </div>
  );
}

/* ══════════════════════════════════════════
   8. 기업정보관리
   ══════════════════════════════════════════ */

function UspContent8() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        기업의 기본 정보와 성과 정보를 등록·수정하고, 현재 이용 중인 입주시설 현황을 관리할 수 있습니다.
      </p>
    </div>
  );
}

function UspContent8_1() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        📌 마이페이지 &gt; AI기업지원 &gt; <MLink to="/MyPage/MemberInfoMmt/EnterpriseInfoMgt">기업정보관리</MLink>
      </p>
      <ul className="menual-list">
        <li>기업정보 카드 영역의 [기업정보 입력] 버튼을 클릭하여 정보를 등록하세요.</li>
        <li>최초 등록: 한 번 등록된 기업 정보는 플랫폼 내 모든 서비스에서 자동으로 활용됩니다.</li>
        <li>수정: 최초 등록 이후에는 버튼 명칭이 [기업정보 수정]으로 변경되며, 변경 사항 발생 시 업데이트할 수 있습니다.</li>
        <li>표시 정보: 기업명, 대표자, 설립년월, 기업규모, 주력분야, 마지막 업데이트 일시를 확인할 수 있습니다.</li>
      </ul>
    </div>
  );
}

function UspContent8_2() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        📌 마이페이지 &gt; AI기업지원 &gt; <MLink to="/MyPage/MemberInfoMmt/EnterpriseInfoMgt">입주기업 성과관리</MLink>
      </p>
      <ul className="menual-list">
        <li>연도별로 진행되는 입주기업 성과조사 목록을 확인하고 자료를 제출할 수 있습니다.</li>
        <li>성과 등록: 목록 우측의 [등록] 버튼을 클릭하여 매출, 고용, 기술 및 사업화 성과 정보를 입력하세요.</li>
        <li>상세 조회: [상세] 버튼을 클릭하면 이전에 제출한 연도별 성과 내역과 증빙서류를 확인할 수 있습니다.</li>
        <li>알림: 성과조사 마감 기간 3일 전부터는 접속 시 팝업을 통해 제출 안내 메시지가 노출됩니다.</li>
      </ul>
    </div>
  );
}

function UspContent8_3() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        📌 마이페이지 &gt; AI기업지원 &gt; <MLink to="/MyPage/MemberInfoMmt/EnterpriseInfoMgt">입주시설관리</MLink>
      </p>
      <ul className="menual-list">
        <li>현재 기업이 입주하여 이용 중인 시설 현황을 조회할 수 있습니다.</li>
        <li>현황 확인: 계약기간, 시설유형(AI 집적단지/창업캠프 1·2호), 입주실 호수, 상주 인원, 입주 상태를 확인하세요.</li>
        <li>정보 수정: [상세] 버튼을 클릭하여 본사 주소와 상주 인원 정보를 직접 수정할 수 있습니다.</li>
        <li>참고: 시설의 최초 등록 및 상세 계약 정보는 관리자에 의해 등록되며 사용자는 일부 항목만 수정 가능합니다.</li>
      </ul>
    </div>
  );
}

/* ══════════════════════════════════════════
   9. 자문단 활동관리 [자문단 전용]
   ══════════════════════════════════════════ */

function UspContent9() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        전문가 자문단 신청 및 자문 요청을 확인하고, 활동 결과보고서를 제출하여 관리할 수 있는 메뉴입니다.
      </p>
    </div>
  );
}

function UspContent9_1() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        📌 마이페이지 &gt; AI기업지원 &gt; <MLink to="/MyPage/MemberInfoMmt/EnterpriseInfoMgt">자문단 활동관리</MLink> &gt; 자문단 지원
      </p>

      <p className="txt">① 자문단 지원</p>
      <ul className="menual-list">
        <li>자문단 신청을 위한 기본 정보를 입력하세요.</li>
        <li>학력사항, 경력사항, 자격증 보유현황, 논문 및 저서 현황, 지재권 보유 현황, 표창 및 수상이력, 대표 관련 강의 이력을 입력하세요.</li>
        <li>자격사항 및 자문 가능 분야를 선택하세요.</li>
        <li>활동 계획 및 관련분야 자문 경력을 입력하세요.</li>
        <li>개인정보 수집 및 이용 동의 후 [신청] 클릭 시 자문단 지원이 완료됩니다.</li>
      </ul>

      <p className="txt">② 지원 확인</p>
      <ul className="menual-list">
        <li>목록에서 지원한 내역의 진행 상태를 확인할 수 있습니다.</li>
        <li>상태 : 신청 / 반려 / 보완요청 / 승인 / 신청취소</li>
        <li>보완요청 시 해당 내역을 클릭하여 사유를 확인하고 내용을 수정하여 재신청하세요.</li>
      </ul>
    </div>
  );
}

function UspContent9_2() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        📌 마이페이지 &gt; AI기업지원 &gt; <MLink to="/MyPage/MemberInfoMmt/EnterpriseInfoMgt">자문단 활동관리</MLink> &gt; 자문단 결과보고 제출
      </p>

      <p className="txt">① 결과보고 등록</p>
      <ul className="menual-list">
        <li>자문이 완료된 건에 대해 [결과보고 등록] 버튼을 클릭하세요.</li>
        <li>자문 일시, 자문 장소 : 실제 진행된 정보를 입력하세요.</li>
        <li>자문 주요 내용 : 상담 및 자문 내용을 상세히 입력하세요.</li>
      </ul>

      <p className="txt">② 증빙자료 첨부</p>
      <ul className="menual-list">
        <li>자문 활동 사진, 수당확인서 등 관련 증빙 자료를 첨부하세요.</li>
        <li>사진제출 파일은 최대 5개 등록 가능</li>
      </ul>

      <p className="txt">③ 제출 완료</p>
      <ul className="menual-list">
        <li>제출 후, 관리자가 결과 보고서를 확인 한 후 해당 자문 건을 완료 처리합니다.</li>
      </ul>
    </div>
  );
}

/* ══════════════════════════════════════════
   10. 이용지원
   ══════════════════════════════════════════ */

function UspContent10() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        공지사항, 소식, 뉴스레터 및 자주묻는질문(FAQ)을 통해 서비스 이용 관련 정보를 확인하고 이벤트에 참여할 수 있습니다.
      </p>
    </div>
  );
}

function UspContent10_1() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        📌 이용지원 &gt; <MLink to="/Notice/Announcement">공지사항</MLink>
      </p>
      <ul className="menual-list">
        <li>검색 : 제목 기준 검색 가능</li>
        <li>목록은 최대 10개씩 노출됩니다.</li>
        <li>게시글 클릭 시 해당 상세 페이지로 이동합니다.</li>
        <li>상세 페이지에서 제목, 등록일, 첨부파일, 본문 내용을 확인할 수 있습니다.</li>
        <li>첨부파일명 클릭 시 해당 파일이 다운로드됩니다.</li>
        <li>[이전 글] / [다음 글] 클릭 시 해당 게시글로 이동합니다.</li>
        <li>[목록] 클릭 시 공지사항 목록으로 이동합니다.</li>
      </ul>
    </div>
  );
}

function UspContent10_2() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        📌 이용지원 &gt; <MLink to="/EventNews/HonsaEvent">소식/행사</MLink>
      </p>
      <ul className="menual-list">
        <li>서비스 관련 소식과 행사 정보를 확인할 수 있습니다.</li>
        <li>목록에서 게시글 제목과 등록일을 확인할 수 있습니다.</li>
        <li>게시글 클릭 시 해당 상세 페이지로 이동합니다.</li>
        <li>상세 페이지에서 제목, 등록일, 첨부파일, 본문 내용을 확인할 수 있습니다.</li>
        <li>[이전 글] / [다음 글] 클릭 시 해당 게시글로 이동합니다.</li>
        <li>[목록] 클릭 시 소식/행사 목록으로 이동합니다.</li>
      </ul>
    </div>
  );
}

function UspContent10_3() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        📌 이용지원 &gt; <MLink to="/EventNews/Newsletter">뉴스레터</MLink>
      </p>
      <ul className="menual-list">
        <li>뉴스레터 목록을 확인할 수 있습니다.</li>
        <li>게시글 클릭 시 해당 상세 페이지로 이동합니다.</li>
        <li>상세 페이지에서 제목, 등록일, 첨부파일, 본문 내용을 확인할 수 있습니다.</li>
        <li>첨부파일명 클릭 시 해당 파일을 다운로드할 수 있습니다.</li>
        <li>[이전 글] / [다음 글] 클릭 시 해당 게시글로 이동합니다.</li>
        <li>[목록] 클릭 시 뉴스레터 목록으로 이동합니다.</li>
      </ul>
    </div>
  );
}

function UspContent10_4() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        📌 이용지원 &gt; <MLink to="http://dev-portal.atops.or.kr/tsp/About/FAQ">자주묻는질문</MLink>
      </p>
      <ul className="menual-list">
        <li>탭 메뉴 : 장비이용/예약 / 비용/결제 / 장비/기술지원</li>
        <li>탭 클릭 시 해당 카테고리 질문 목록으로 변경됩니다.</li>
        <li>질문 항목 클릭 시 답변이 펼쳐지는 아코디언 방식으로 표시됩니다.</li>
      </ul>
    </div>
  );
}

function UspContent10_5() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        📌 이용지원 &gt; <MLink to="/EventNews/Event">이벤트</MLink>
      </p>
      <ul className="menual-list">
        <li>진행 중인 이벤트 및 종료된 이벤트 정보를 확인할 수 있습니다.</li>
        <li>게시글 클릭 시 해당 상세 페이지로 이동합니다.</li>
        <li>상세 페이지에서 제목, 기간, 본문 내용을 확인할 수 있습니다.</li>
        <li>[목록] 클릭 시 이벤트 목록으로 이동합니다.</li>
      </ul>
    </div>
  );
}

/* ══════════════════════════════════════════
   11. 1:1 문의 (USP 경로)
   ══════════════════════════════════════════ */

function UspContent11_1() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        📌 이용지원 &gt; <MLink to="/SupportForUse/OneByOneInquiry">1:1문의</MLink> &gt; [문의 등록]
      </p>
      <ul className="menual-list">
        <li>구분을 선택하세요. : 전체 / AI 기업지원 / 사업관리시스템 / AI 실증지원 / AI 데이터지원</li>
        <li>제목을 입력하세요.</li>
        <li>문의 내용을 입력하세요.</li>
        <li>첨부파일을 등록하세요.</li>
        <li>공개 설정 : 공개글 / 비밀글 선택 (기본값 : 비밀글)</li>
        <li>[완료] 클릭 시 문의가 등록됩니다.</li>
        <li>[취소] 클릭 시 이전 페이지로 이동합니다.</li>
      </ul>
    </div>
  );
}

function UspContent11_2() {
  return (
    <div className="menual-panel-body-inner">
      <p className="txt">
        📌 마이페이지 &gt; <MLink to="/MyPage/InquiryMmt/OneByOneMmt">1:1문의내역</MLink>
      </p>
      <ul className="menual-list">
        <li>구분 필터 : 전체 / AI 기업지원 / 사업관리시스템 / AI 실증지원 / AI 데이터지원</li>
        <li>검색 : 제목 기준 검색 가능</li>
        <li>작성자는 가운데 자리 마스킹(*) 처리되어 노출됩니다.</li>
        <li>목록은 최대 10개씩 노출됩니다.</li>
        <li>게시글 클릭 시 해당 상세 페이지로 이동합니다.</li>
        <li>상세 페이지에서 제목, 구분, 작성자, 등록일, 내용, 첨부파일을 확인할 수 있습니다.</li>
        <li>담당자 답변이 등록된 경우 답변 내용을 확인할 수 있습니다.</li>
        <li>[이전 글] / [다음 글] 클릭 시 해당 게시글로 이동합니다.</li>
      </ul>
    </div>
  );
}

/* ══════════════════════════════════════════
   switch
   ══════════════════════════════════════════ */

export function renderUspContent(key: string): React.ReactNode {
  switch (key) {
    case 'usp-1':
      return <UspContent1 />;
    case 'usp-2':
      return <TspContent2 />;
    case 'usp-2-1':
      return <TspContent2_1 />;
    case 'usp-2-2':
      return <TspContent2_2 />;
    case 'usp-2-3':
      return <TspContent2_3 />;
    case 'usp-2-4':
      return <TspContent2_4 />;
    case 'usp-3':
      return <TspContent3 />;
    case 'usp-3-1':
      return <TspContent3_1 />;
    case 'usp-3-2':
      return <TspContent3_2 />;
    case 'usp-3-3':
      return <TspContent3_3 />;
    case 'usp-3-4':
      return <TspContent3_4 />;
    case 'usp-4':
      return <UspContent4 />;
    case 'usp-4-1':
      return <UspContent4_1 />;
    case 'usp-4-2':
      return <UspContent4_2 />;
    case 'usp-4-2-1':
      return <UspContent4_2_1 />;
    case 'usp-4-2-2':
      return <UspContent4_2_2 />;
    case 'usp-4-3':
      return <UspContent4_3 />;
    case 'usp-4-3-1':
      return <UspContent4_3_1 />;
    case 'usp-4-3-2':
      return <UspContent4_3_2 />;
    case 'usp-5':
      return <UspContent5Intro />;
    case 'usp-5-1':
      return <UspContent5_1 />;
    case 'usp-6':
      return <UspContent6 />;
    case 'usp-6-1':
      return <UspContent6_1 />;
    case 'usp-6-2':
      return <UspContent6_2 />;
    case 'usp-6-3':
      return <UspContent6_3 />;
    case 'usp-6-4':
      return <UspContent6_4 />;
    case 'usp-6-5':
      return <UspContent6_5 />;
    case 'usp-6-6':
      return <UspContent6_6 />;
    case 'usp-7':
      return <DashboardManualBody dashboardTo="/MyPage/Dashboard" />;
    case 'usp-8':
      return <UspContent8 />;
    case 'usp-8-1':
      return <UspContent8_1 />;
    case 'usp-8-2':
      return <UspContent8_2 />;
    case 'usp-8-3':
      return <UspContent8_3 />;
    case 'usp-9':
      return <UspContent9 />;
    case 'usp-9-1':
      return <UspContent9_1 />;
    case 'usp-9-2':
      return <UspContent9_2 />;
    case 'usp-10':
      return <UspContent10 />;
    case 'usp-10-1':
      return <UspContent10_1 />;
    case 'usp-10-2':
      return <UspContent10_2 />;
    case 'usp-10-3':
      return <UspContent10_3 />;
    case 'usp-10-4':
      return <UspContent10_4 />;
    case 'usp-10-5':
      return <UspContent10_5 />;
    case 'usp-11':
      return <TspContent8 />;
    case 'usp-11-1':
      return <UspContent11_1 />;
    case 'usp-11-2':
      return <UspContent11_2 />;
    default:
      return null;
  }
}
